<template>
  <div class="vacancy-list-container vacancy">
    <div v-if="vacancies != ''" class="vacancy-list d-flex flex-column">
      <div class="vacancy-item" v-for="(item, index) in vacancies" :key="index">
        <div class="text-left">
          <router-link
            :to="getVacancyLink(item)"
            class="vacancy-title text-decoration-none"
            >{{ item.title }}</router-link
          >
        </div>
      </div>
      <pagination
        class="mt-4"
        v-model="currentPage"
        :selector="'.vacancy'"
        :totalPageCount="totalPageCount"
      />
    </div>
    <div v-else>
      <div class="no-vacancies">{{$t('listVacancy.openVacancies')}}</div>
    </div>

    <v-overlay :value="overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>
<script>
import serviceDataAccess from '../../../services/service.data-access'
import Pagination from '../../_shared/Pagination.vue'
export default {
  components: { Pagination },
  name: 'VacancyList',
  data: () => ({
    overlay: false,
    currentPage: 1,
    totalCount: 0,
    totalPageCount: 0,
    vacancies: null,
    filterModel: {
      pageSize: 12,
      pageIndex: 0
    }
  }),
  props: ['model'],
  computed: {
    content: function () {
      return this.model.content
    }
  },
  async created() {
    await this.loadVacancies(this.filterModel)
  },
  methods: {
    async loadVacancies() {
      this.overlay = true
      const result = await serviceDataAccess.getVacancies(this.filterModel)
      this.vacancies = result.data
      this.totalCount = result.totalCount
      this.totalPageCount = result.totalPageCount
      this.overlay = false
    },
    getVacancyLink(item) {
      return {
        name: 'subDynamic',
        params: {
          urlKey: this.model.metadata.vacancyDetailsUrlKey,
          subUrlKey: item.urlKey
        }
      }
    }
  },
  watch: {
    currentPage: function (newVal, oldVal) {
      if (newVal !== oldVal) {
        this.filterModel.pageIndex = newVal - 1
        this.loadVacancies(this.filterModel)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.vacancy-list {
  .vacancy-item {
    background-color: #ffffff;
    padding: 1.6rem;

    &:not(:first-of-type) {
      margin-top: 2rem;
    }
    .vacancy-title {
      font-size: 2.4rem;
    }
  }
}
.no-vacancies {
  font-size: 2rem;
  text-align: center;
  background-color: white;
  padding: 1.5rem;
}
</style>
